import { render, staticRenderFns } from "./chat_list.vue?vue&type=template&id=cd1cfa4a&"
import script from "./chat_list.vue?vue&type=script&lang=js&"
export * from "./chat_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports